enum RequesterInputType {
  CHECKBOX = 'checkbox',
  IMAGE = 'image',
  TEXT = 'text',
}

export default RequesterInputType;
